/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class NextStepsFilter {
    public static filter(): any {
        return (input: any): any => {
            if (input instanceof Array && input.length > 0) {
                return input.map((elem: any) => {
                    if (elem instanceof String) {
                        return elem.split('_').map((sub_elem: string) => {
                            return sub_elem.charAt(0).toUpperCase() + sub_elem.slice(1);
                        }).join(' ');
                    }
                }).join(' > ');
            } else {
                return 'Done';
            }
        };
    }
}


angular.module('beneple.process')
    .filter('next_steps', NextStepsFilter.filter);



// WEBPACK FOOTER //
// ./frontend/scripts/process/filters/next_steps.filter.ts